/**
 * Created by mathias.gamperl on 25.11.2014.
 */
export default ["$q", "Events","ConfigService", "AuthenticationService", "MenuService", "LocaleService", "$rootScope", "$timeout", "matchmedia",
  function dcNavigation($q, Events,ConfigService, AuthenticationService, MenuService, LocaleService, $rootScope, $timeout, matchmedia) {

    return {
      restrict: "EA",
      replace: true,
      template: require("./dc-navigation.tpl.html"),
      controller: ["$scope", function ($scope) {        

        $scope.sidebarTextKey = "navbar.menuMin";
        $scope.sidebarText = LocaleService.getString($scope.sidebarTextKey);

        $scope.sidebarMinimized = false;

        $scope.menues = MenuService.getMenus();
        $scope.locales = LocaleService.getLocales();

        $scope.getMenus = function () {
          return MenuService.getMenus();
        };

        $scope.getLocaleUrl = function (locale) {
          return LocaleService.getLocaleUrl(locale);
        };

        $scope.changeLocale = function (locale) {
          LocaleService.switchLocale(locale);
        };

        $scope.isActive = function (menu) {
          return MenuService.isActive(menu);
        };

        $scope.isOpen = function (menu) {
          return MenuService.isOpen(menu);
        };

        $scope.go = function (menu) {
          return MenuService.go(menu);
        };

        $scope.shouldShowMenu = function (menu) {
          return MenuService.shouldShowMenu(menu);
        };

        $scope.toggle = MenuService.toggle;


        $scope.isMenuVisible = (menu) => {
          return MenuService.isMenuVisible(menu);
        };

        $scope.closeMenuOnPhone = function () {
          if (matchmedia.isPhone()) {
            $rootScope.$emit(Events.NAV_TOGGLE_MENU, true);
          }
        };

        $scope.collapseOthers = function (menu) {
          MenuService.collapseOthers(menu);
        };

        function toggleSidebar(data) {
          $timeout(function () {
            $scope.sidebarMinimized = data;
            if ($scope.sidebarMinimized) {
              $scope.sidebarTextKey = "navbar.menuMax";
              $scope.sidebarText = LocaleService.getString($scope.sidebarTextKey);
            }
            else {
              $scope.sidebarTextKey = "navbar.menuMin";
              $scope.sidebarText = LocaleService.getString($scope.sidebarTextKey);
            }

          });
        }

        function toggleMenu(data) {
          $timeout(function () {
            // anything you want can go here and will safely be run on the next digest.
            // console.log("main menu collapsed", data);
            $scope.mainMenuCollapsed = data;
          });
        }

        var unregisterTablet = matchmedia.onTablet(function (mediaQueryList) {
          $timeout(function () {
            $rootScope.$emit(Events.NAV_TOGGLE_SIDEBAR, true);
            $rootScope.$emit(Events.NAV_TOGGLE_MENU, true);
          }, 10);
        });

        //initial load (page-container is loaded first so we have to do this on our own
        var unregisterPhone = matchmedia.onPhone(function (mediaQueryList) {
          $timeout(function () {
            $rootScope.$emit(Events.NAV_TOGGLE_SIDEBAR, false);
            $rootScope.$emit(Events.NAV_TOGGLE_MENU, true);
          }, 10);
        });

        var unregisterDesktop = matchmedia.onDesktop(function (mediaQueryList) {
          $timeout(function () {
            $rootScope.$emit(Events.NAV_TOGGLE_SIDEBAR, false);
          }, 10);
        });

        var onToggleSidebar = $scope.$on(Events.NAV_TOGGLE_SIDEBAR, function (e, data) {
          //console.log("Toggle Sidebar");
          toggleSidebar(data);
        });

        var onToggleMenu = $rootScope.$on(Events.NAV_TOGGLE_MENU, function (e, data) {
          toggleMenu(data);
        });

        $scope.$on("$destroy", function () {
          onToggleSidebar();
          onToggleMenu();
          unregisterTablet();
          unregisterPhone();
          unregisterDesktop();
        });

        //updateMenu();

        function init() {
          if (matchmedia.isPhone()) {
            //toggleMenu(true);
            $rootScope.$emit(Events.NAV_TOGGLE_MENU, true);
          }

          if (matchmedia.isTablet()) {
            //toggleSidebar(true);
            $rootScope.$emit(Events.NAV_TOGGLE_SIDEBAR, true);
          }
        }

        $timeout(() => {
          init();
        }, 50);

      }],
      link: function (scope, elem, attrs) {

      }
    };

  }];



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-navigation/dc-navigation.js